import { createFileRoute, redirect } from "@tanstack/react-router";

// Cost-code rollup → Variance to Budget by Cost Code
export const Route = createFileRoute("/_auth/reports/cost-code-rollup")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "0ae2e0e0-dbcc-5a1d-8a63-d29ff3269834" }, replace: true });
  },
  component: () => null,
});
